import colorPattern from '../../../DesignSystem/colors'

const lightSurfaceColors = {
    'background-primary': colorPattern.tahitian,
    'background-secondary': colorPattern.pearl,
    'background-invert': colorPattern.onyx,
    'background-brand-primary': colorPattern.cyan,
    'background-brand-secondary': colorPattern.purple,
    'background-tertiary': colorPattern.ghost,
} as const

export default lightSurfaceColors
